import React, { useRef, useState } from 'react';
import Button from '../button/Button';
import styled from 'styled-components';
import Plus from '../icons/Plus';
import Box from '../layout/Box';
import Text from '../text/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AccordionItem = styled(Box).attrs({
  as: 'li',
  $mt: 8,
  $styles: {
    border: '1px solid transparent',
    borderRadius: 16,
    background: 'rgba(5, 0, 56, 0.05)'
  }
}).withConfig({
  displayName: "AccordionButton__AccordionItem",
  componentId: "sc-opx1ed-0"
})(["", ""], function (_ref) {
  var $isFocused = _ref.$isFocused,
      theme = _ref.theme;
  return $isFocused && theme.normalizeStyles(theme.focus.outlines["default"]);
});
var IconWrapper = styled.div.withConfig({
  displayName: "AccordionButton__IconWrapper",
  componentId: "sc-opx1ed-1"
})(["opacity:0.4;transition:250ms ease;transition-property:opacity,transform;", ":hover &,&.is-expanded{opacity:1;}&.is-expanded{transform:rotate(45deg);}"], AccordionItem);
var HeaderButton = styled(Button).withConfig({
  displayName: "AccordionButton__HeaderButton",
  componentId: "sc-opx1ed-2"
})(["display:block;width:100%;text-align:left;"]);
var AccordionItemHeader = styled(Box).attrs(function (_ref2) {
  var $isExpanded = _ref2.$isExpanded;
  return {
    $styles: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: [20, 40],
      paddingBottom: $isExpanded ? [16, 28] : [24, 44],
      paddingLeft: [24, 40],
      paddingRight: [24, 40]
    }
  };
}).withConfig({
  displayName: "AccordionButton__AccordionItemHeader",
  componentId: "sc-opx1ed-3"
})([""]);
var AccordionItemContent = styled(Text).attrs({
  as: 'section',
  $styles: {
    color: 'rgba(5, 0, 56, 0.6)',
    maxWidth: [null, 645],
    paddingBottom: [24, 32],
    paddingLeft: [24, 40],
    paddingRight: [24, 40],
    display: 'none',
    '&.is-expanded': {
      display: 'block'
    }
  }
}).withConfig({
  displayName: "AccordionButton__AccordionItemContent",
  componentId: "sc-opx1ed-4"
})([""]);

var AccordionButtonBase = function AccordionButtonBase(_ref3) {
  var id = _ref3.id,
      headline = _ref3.headline,
      content = _ref3.content,
      defaultExpanded = _ref3.defaultExpanded,
      showContentInDom = _ref3.showContentInDom;

  var _useState = useState(defaultExpanded || false),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  var _useState2 = useState(false),
      isFocused = _useState2[0],
      setFocused = _useState2[1];

  var contentId = "accordion-content-".concat(id);
  var accordionHeaderId = "accordion-header-".concat(id);
  var buttonRef = useRef(null);
  return /*#__PURE__*/_jsxs(AccordionItem, {
    $isFocused: isFocused,
    children: [/*#__PURE__*/_jsx(HeaderButton, {
      ref: buttonRef,
      onClick: function onClick() {
        return setIsExpanded(!isExpanded);
      },
      onFocus: function onFocus(e) {
        if (e.target === buttonRef.current) {
          setFocused(true);
        }
      },
      onBlur: function onBlur(e) {
        setFocused(false);
      },
      "aria-expanded": isExpanded,
      "aria-controls": contentId,
      id: accordionHeaderId,
      children: /*#__PURE__*/_jsxs(AccordionItemHeader, {
        $isExpanded: isExpanded,
        children: [/*#__PURE__*/_jsx(Box, {
          $styles: {
            maxWidth: [225, 740]
          },
          children: headline
        }), /*#__PURE__*/_jsx(IconWrapper, {
          className: isExpanded ? 'is-expanded' : undefined,
          "aria-hidden": true,
          children: /*#__PURE__*/_jsx(Plus, {})
        })]
      })
    }), (isExpanded || showContentInDom) && /*#__PURE__*/_jsx(AccordionItemContent, {
      id: contentId,
      "aria-labelledby": accordionHeaderId,
      $variant: ['p1', 'p0'],
      className: isExpanded ? 'is-expanded' : undefined,
      children: content
    })]
  });
};

export default AccordionButtonBase;